var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUdi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47585 4.72727H9.5767V9.51065C9.5767 10.0196 9.45715 10.4706 9.21804 10.8636C8.97893 11.2543 8.64276 11.562 8.20952 11.7869C7.77628 12.0095 7.26847 12.1207 6.68608 12.1207C6.10606 12.1207 5.59943 12.0095 5.16619 11.7869C4.73295 11.562 4.39678 11.2543 4.15767 10.8636C3.91856 10.4706 3.79901 10.0196 3.79901 9.51065V4.72727H4.89631V9.42188C4.89631 9.75095 4.96851 10.0433 5.11293 10.299C5.25971 10.5547 5.46686 10.7559 5.73438 10.9027C6.00189 11.0471 6.31913 11.1193 6.68608 11.1193C7.0554 11.1193 7.37382 11.0471 7.64134 10.9027C7.91122 10.7559 8.11719 10.5547 8.25923 10.299C8.40365 10.0433 8.47585 9.75095 8.47585 9.42188V4.72727ZM13.5265 12H11.1721V4.72727H13.601C14.3136 4.72727 14.9256 4.87287 15.437 5.16406C15.9483 5.45289 16.3401 5.86837 16.6124 6.41051C16.887 6.95028 17.0243 7.59777 17.0243 8.35298C17.0243 9.11056 16.8858 9.7616 16.6088 10.3061C16.3342 10.8506 15.9365 11.2696 15.4157 11.5632C14.8948 11.8544 14.2651 12 13.5265 12ZM12.2694 11.0412H13.4661C14.0201 11.0412 14.4805 10.937 14.8475 10.7287C15.2144 10.518 15.4891 10.2138 15.6713 9.81605C15.8536 9.41596 15.9448 8.92827 15.9448 8.35298C15.9448 7.78243 15.8536 7.2983 15.6713 6.90057C15.4914 6.50284 15.2227 6.20099 14.8652 5.99503C14.5078 5.78906 14.0639 5.68608 13.5336 5.68608H12.2694V11.0412ZM19.4862 4.72727V12H18.3888V4.72727H19.4862Z",
    fill: "#3C6E8E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    stroke: "#3C6E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdi);
export default __webpack_public_path__ + "static/media/udi.d411690db87e8f1557ed246d8815c7ff.svg";
export { ForwardRef as ReactComponent };